var _a;
import { proxy, useSnapshot } from 'valtio';
const tabVisibilityStore = proxy({
    isVisible: true,
});
(_a = globalThis.window) === null || _a === void 0 ? void 0 : _a.document.addEventListener('visibilitychange', () => {
    tabVisibilityStore.isVisible = document.visibilityState === 'visible';
});
export const useTabIsVisible = () => {
    const snapshot = useSnapshot(tabVisibilityStore);
    return { isVisible: snapshot.isVisible };
};
